<template>
    <div class="data page">
        <main>
            <form @submit.prevent="nextStep">
                <div class="container-fluid">
                    <div class="row pb-24">
                        <div class="col-3 pt-24">
                            <button type="button" @click.prevent="$router.back" class="btn-icon icon-caret-left"></button>
                        </div>
                        <div class="col-12 col-lg-6">
                            <div class="step pt-24">
                                <div class="d-flex justify-content-between">
                                    <h1 class="h1">Mijn gegevens</h1>
                                    <h2 class="h1">Stap 1 van 3</h2>
                                </div>
                                <button v-if="!$loggedIn" @click.prevent="$login" class="btn-login">Inloggen bij het IDD</button>

                                <div v-if="!$loggedIn" class="step__intro pt-24 pb-24">
                                    <p>
                                      Vul uw gegevens in en geef uw voorkeuren door
                                    </p>
                                </div>

                                <div class="step__part">
                                    <div class="form-row">
                                        <div class="form-field form-field__radio">
                                            <label class="form-field__radio--label">Geslacht</label>
                                            <div class="radio-field">
                                                <input type="radio" v-model="data.gender" required checked id="Male" value="Man" name="gender">
                                                <label for="Male">Man</label>
                                            </div>
                                            <div class="radio-field">
                                                <input type="radio" v-model="data.gender" required id="Female" value="Vrouw" name="gender">
                                                <label for="Female">Vrouw</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="step__part">
                                    <h3 class="h2">Persoonlijke gegevens</h3>
                                    <div class="form-row">
                                        <div class="form-field w-m-30 w-20">
                                            <input type="text" v-model="data.initials" required maxlength="15" placeholder="Voorletters*">
                                        </div>
                                        <div class="form-field w-m-20 w-30">
                                            <input type="text" v-model="data.affex" placeholder="Tussenv.">
                                        </div>
                                        <div class="form-field w-50">
                                            <input type="text" v-model="data.surname" required maxlength="127" placeholder="Achternaam*">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-field w-50">
                                            <input type="email" v-model="data.email" required maxlength="127" placeholder="E-mailadres*">
                                        </div>
                                        <div class="form-field w-50">
                                            <input type="tel" v-model="data.phone" required minlength="8" maxlength="15" placeholder="Telefoon*">
                                        </div>
                                    </div>
                                </div>

                                <div class="step__part">
                                    <h3 class="h2">Adresgegevens</h3>
                                    <div class="form-row">
                                        <div class="form-field w-m-60 w-70">
                                            <input type="text" placeholder="Straatnaam*" required maxlength="127" v-model="data.street_name">
                                        </div>
                                        <div class="form-field w-20 pr-0">
                                            <input class="border-right-0 br-0" type="number" required maxlength="127" v-model="data.house_number" placeholder="Huisnum.*">
                                        </div>
                                        <div class="form-field w-m-20 w-10">
                                            <input type="text" class="bl-0" v-model="data.house_number_addition" placeholder="Toev.">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-field w-30">
                                            <input type="text" v-model="data.zip_code" required minlength="6" maxlength="7" placeholder="Postcode*">
                                        </div>
                                        <div class="form-field w-70">
                                            <input type="text" v-model="data.city" required maxlength="127" placeholder="Plaats*">
                                        </div>
                                    </div>
                                </div>


                                <div class="step__part">
                                    <h3 class="h2">Geboortegegevens</h3>
                                    <p>Uw geboorte datum gelieve op de volgende manier in te vullen (dd-mm-jjjj).</p>
                                    <div class="form-row">
                                        <birth-input class="w-60" v-model="data.birth_date"></birth-input>
                                        <div class="form-field w-40">
                                            <input type="text" v-model="data.birth_place" required maxlength="127" placeholder="Geboorteplaats*">
                                        </div>
                                    </div>
                                </div>

                                <div class="step__part">
                                    <h3 class="h2">Burgelijke staat</h3>
                                    <div class="form-row">
                                        <div class="form-field w-m-100 w-80">
                                            <select required v-model="data.civilian_state">
                                                <option :value="undefined" disabled selected>Kies een optie *</option>
                                                <option value="Alleenstaand">Alleenstaand</option>
                                                <option value="Gehuwd (gemeenschap)">Gehuwd (gemeenschap)</option>
                                                <option value="Gehuwd (huwelijkse voorwaarden)">Gehuwd (huwelijkse voorwaarden)</option>
                                                <option value="Geregistreerd partner">Geregistreerd partner</option>
                                                <option value="Ongehuwd">Ongehuwd</option>
                                                <option value="Overige">Overige</option>
                                                <option value="Samenwonend">Samenwonend</option>
                                                <option value="Weduwe">Weduwe</option>
                                                <option value="Weduwnaar">Weduwnaar</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="step__part">
                                    <h3 class="h2">Waar kent u ons van?</h3>
                                    <div class="form-row">
                                        <div class="form-field w-m-100 w-80">
                                            <select required v-model="data.origin">
                                                <option :value="undefined" disabled selected>Kies een optie *</option>
                                                <option value="Advertentie">Advertentie</option>
                                                <option value="Bezoeker">Bezoeker</option>
                                                <option value="Funda">Funda</option>
                                                <option value="Krant">Krant</option>
                                                <option value="Mailing">Mailing</option>
                                                <option value="Medewerker">Medewerker</option>
                                                <option value="Mond tot mond reclame">Mond tot mond reclame</option>
                                                <option value="Telefoongids">Telefoongids</option>
                                                <option value="Zoekmachine">Zoekmachine</option>
                                                <option value="Overig">Overig</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
<!--                        <div class="col-3 pt-24 d-none d-lg-block">-->
<!--                            <div class="h-100 d-flex justify-content-end">-->
<!--                                <div class="tooltip-wrap">-->
<!--                                    <a class="tooltip-btn">Info</a>-->
<!--                                    <div class="tooltip-content">-->
<!--                                        Tooltip over twee regels.-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>

                    <div class="row justify-content-center step-grey">
                        <div class="col-12 col-lg-6">

                            <div class="toggle-partner" :class="{ open: showPartner }" @click="showPartner = !showPartner">
                                <h3 class="h3">Ik wil mij samen registreren met mijn partner</h3>
                                <div class="toggle-partner__icon">
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>

                            <div class="partner-wrapper" v-if="showPartner" :class="{ open: showPartner }">
                                <div class="step__part">
                                    <div class="form-row">
                                        <div class="form-field form-field__radio">
                                            <label class="form-field__radio--label">Geslacht</label>
                                            <div class="radio-field">
                                                <input type="radio" v-model="data.partner_gender" required checked id="partnerMale" value="Man" name="partner_gender">
                                                <label for="partnerMale">Man</label>
                                            </div>
                                            <div class="radio-field">
                                                <input type="radio" v-model="data.partner_gender" required id="partnerFemale" value="Vrouw" name="partner_gender">
                                                <label for="partnerFemale">Vrouw</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="step__part">
                                    <h3 class="h2">Persoonlijke gegevens</h3>
                                    <div class="form-row">
                                        <div class="form-field w-m-30 w-20">
                                            <input type="text" v-model="data.partner_initials" required maxlength="15" placeholder="Voorletters*">
                                        </div>
                                        <div class="form-field w-m-20 w-30">
                                            <input type="text" v-model="data.partner_affex" placeholder="Tussenv.">
                                        </div>
                                        <div class="form-field w-50">
                                            <input type="text" v-model="data.partner_surname" required maxlength="127" placeholder="Achternaam">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-field w-50">
                                            <input type="email" v-model="data.partner_email" required maxlength="127" placeholder="E-mailadres*">
                                        </div>
                                        <div class="form-field w-50">
                                            <input type="tel" v-model="data.partner_phone" required minlength="8" maxlength="15" placeholder="Telefoon*">
                                        </div>
                                    </div>
                                </div>

                                <div class="step__part">
                                    <h3 class="h2">Adresgegevens</h3>
                                    <div class="form-row">
                                        <div class="form-field w-m-60 w-70">
                                            <input type="text" v-model="data.partner_street_name" required maxlength="127" placeholder="Straatnaam">
                                        </div>
                                        <div class="form-field w-20 pr-0">
                                            <input class="border-right-0 br-0" v-model="data.partner_house_number" required type="number" placeholder="Huisnum.">
                                        </div>
                                        <div class="form-field w-m-20 w-10">
                                            <input type="text" class="bl-0" v-model="data.partner_house_number_addition" placeholder="Toev.">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-field w-30">
                                            <input type="text" v-model="data.partner_zip_code" required minlength="6" maxlength="7" placeholder="Postcode">
                                        </div>
                                        <div class="form-field w-70">
                                            <input type="text" v-model="data.partner_city" required maxlength="127" placeholder="Plaats">
                                        </div>
                                    </div>
                                </div>


                                <div class="step__part">
                                    <h3 class="h2">Geboortegegevens</h3>
                                    <p>Uw geboorte datum gelieve op de volgende manier in te vullen (dd-mm-jjjj).</p>
                                    <div class="form-row">
                                        <birth-input class="w-60" v-model="data.partner_birth_date"></birth-input>
                                        <div class="form-field w-40">
                                            <input type="text" v-model="data.partner_birth_place" required maxlength="127" placeholder="Geboorteplaats*">
                                        </div>
                                    </div>
                                </div>

                                <div class="step__part">
                                    <h3 class="h2">Burgelijke staat</h3>
                                    <div class="form-row">
                                        <div class="form-field w-m-100 w-80">
                                            <select required v-model="data.partner_civilian_state">
                                                <option :value="undefined" disabled selected>Kies een optie</option>
                                                <option value="Alleenstaand">Alleenstaand</option>
                                                <option value="Gehuwd (gemeenschap)">Gehuwd (gemeenschap)</option>
                                                <option value="Gehuwd (huwelijkse voorwaarden)">Gehuwd (huwelijkse voorwaarden)</option>
                                                <option value="Geregistreerd partner">Geregistreerd partner</option>
                                                <option value="Ongehuwd">Ongehuwd</option>
                                                <option value="Overige">Overige</option>
                                                <option value="Samenwonend">Samenwonend</option>
                                                <option value="Weduwe">Weduwe</option>
                                                <option value="Weduwnaar">Weduwnaar</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row justify-content-center">
                        <div class="col-12 col-lg-6">
                            <div class="step__footer text-right">
                                <button type="submit" class="btn btn-primary">Volgende</button>
                            </div>
                        </div>
                    </div>

                </div>
            </form>
        </main>
    </div>
</template>


<script>

    import BirthInput from '../components/fields/BirthInput'

    export default {
        components: {
            BirthInput
        },
        data() {
            return {
                data: {
                    gender: null
                },
                showPartner: false,
                parent: this.$parent,
            }
        },
        mounted(){
            if(Object.keys(this.$store.state.form).length > 0){
                this.data = this.$store.state.form
            } else {
                this.prefill()
            }
            if(this.data.partner_surname){
                this.showPartner = true
            }
        },
        watch: {
            $user() {
                this.prefill()
            }
        },
        methods: {

            nextStep () {
                this.$store.commit('saveStep',this.data)
                this.$router.push({name: 'step2' })
            },
            prefill () {
                if(!this.$user){
                    return
                }
                let user = this.$user
                console.log(user)
                let partner = []
                if(user.partner) {
                    partner = Object.entries(user.partner)
                }

                // set user data
                Object.entries(user).forEach((row) => {
                    let name = row[0]
                    let value = row[1]
                    if(value && typeof value !== 'object'){
                        if(!this.data[name]) {
                            this.$set(this.data, name, value)
                        }
                    }
                })

                // set partner data
                if(partner.length > 0){
                    this.showPartner = true
                    partner.forEach((row) => {
                        let name = row[0]
                        let value = row[1]
                        if(value && typeof value !== 'object'){
                            if(!this.data['partner_' + name]) {
                                this.$set(this.data, 'partner_' + name, value)
                            }
                        }
                    })
                }

            }
        }
    }
</script>
